/**
 * SidebarNavItem - Navigation item for main sections
 *
 * Used for:
 * - Home
 * - Watchlist
 * - Feedback
 * - Settings
 */

import React from 'react';
import { TouchableOpacity, Text, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { Colors } from '@/constants/colors';

interface SidebarNavItemProps {
  icon: keyof typeof Ionicons.glyphMap;
  label: string;
  isActive?: boolean;
  isExpanded: boolean;
  onPress: () => void;
}

export const SidebarNavItem: React.FC<SidebarNavItemProps> = ({
  icon,
  label,
  isActive = false,
  isExpanded,
  onPress,
}) => {
  const handlePress = () => {
    console.log('[SidebarNavItem] Clicked:', label);
    onPress();
  };

  return (
    <TouchableOpacity
      style={[styles.item, isActive && styles.itemActive]}
      onPress={handlePress}
      activeOpacity={0.7}
      // @ts-ignore - Web-only property for better click handling
      accessibilityRole="button"
    >
      <Ionicons
        name={icon}
        size={24}
        color={isActive ? Colors.accent.primary : Colors.text.tertiary}
      />

      {isExpanded && <Text style={[styles.label, isActive && styles.labelActive]}>{label}</Text>}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  item: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 16,
    // @ts-ignore - Web-only property
    transition: 'background-color 150ms ease',
    // @ts-ignore - Web-only property
    cursor: 'pointer',
  },
  itemActive: {
    backgroundColor: Colors.background.tertiary,
    borderLeftWidth: 3,
    borderLeftColor: Colors.accent.primary,
  },
  label: {
    marginLeft: 16,
    fontSize: 14,
    fontWeight: '500',
    color: Colors.text.secondary,
    // @ts-ignore - Web-only property
    animation: 'fadeIn 150ms ease-in 50ms both',
  },
  labelActive: {
    color: Colors.accent.primary,
    fontWeight: '600',
  },
});
